module.exports = __webpack_public_path__ + "static/bed-frame-3-e500cb80deea1af1d6a39d61455b8412.png";